var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Auth, CognitoUser } from '@aws-amplify/auth';
import { debug as createDebugger } from 'debug';
import { allUserRoles } from "../constants/user-role";
import { parseAvailableService } from "../helpers/available-service-helpers";
var debug = createDebugger('auth');
export var allSchoolTypes = ['ELEMENTARY_SCHOOL', 'MIDDLE_SCHOOL', 'COMPULSORY_EDUCATION_SCHOOL'];
function validateUserRole(userRoleRaw) {
    return allUserRoles.find(function (userRole) { return userRole === userRoleRaw; });
}
function validateSchoolType(schoolTypeRaw) {
    return allSchoolTypes.find(function (schoolType) { return schoolType === schoolTypeRaw; });
}
/** 文字列型を数値型へパースする。（NaNをundefinedに丸める） */
function parseIntSafe(str) {
    var result = parseInt(str || '', 10);
    return Number.isNaN(result) ? undefined : result;
}
function validateUser(payload) {
    var userId = parseIntSafe(payload['custom:userId']);
    var userName = payload.preferred_username;
    var userRole = validateUserRole(payload['custom:role']);
    var cloudId = payload['custom:cloudId'];
    var schoolId = payload['custom:schoolId'];
    var schoolType = validateSchoolType(payload['custom:schoolType']);
    var availableServicesRaw = payload['custom:availableServices'];
    var availableService = parseAvailableService({ availableServicesRaw: availableServicesRaw, userRole: userRole, isCreatingAssignment: false });
    var availableServiceForCreatingAssignment = parseAvailableService({
        availableServicesRaw: availableServicesRaw,
        userRole: userRole,
        isCreatingAssignment: true,
    });
    if (userId == null)
        throw new Error('Invalid custom attribute: userId');
    if (userRole == null)
        throw new Error('Invalid custom attribute: userRole');
    if (schoolType == null)
        throw new Error('Invalid custom attribute: schoolType');
    if (availableService == null || availableServiceForCreatingAssignment == null) {
        throw new Error('Invalid custom attribute: availableServices');
    }
    return {
        userId: userId,
        userName: userName,
        userRole: userRole,
        cloudId: cloudId,
        schoolId: schoolId,
        schoolType: schoolType,
        availableService: availableService,
        availableServiceForCreatingAssignment: availableServiceForCreatingAssignment,
    };
}
function isCognitoError(error) {
    if (error instanceof Error)
        return false; // cognitoの認証エラーはErrorのインスタンスで返ってこないのでfalse
    if (error === 'No current user')
        return true;
    if (typeof error === 'object' && error.code === 'NotAuthorizedException')
        return true;
    return false;
}
/**
 * useAuthのための認証を管理するContextProvider。
 */
export var AuthProvider = function (props) {
    var _a, _b;
    var env = props.env, children = props.children;
    var _c = useState(false), isAuthReady = _c[0], setIsAuthReady = _c[1];
    var _d = useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(), user = _e[0], setUser = _e[1];
    var ignoreRedirection = (_a = env === null || env === void 0 ? void 0 : env.ignoreRedirection) !== null && _a !== void 0 ? _a : false;
    var ignoreCookie = (_b = env === null || env === void 0 ? void 0 : env.ignoreCookie) !== null && _b !== void 0 ? _b : false;
    useEffect(function () {
        setIsLoading(true);
        Auth.currentSession()
            .then(function (data) {
            var userPayload = data.getIdToken().decodePayload();
            setUser(validateUser(userPayload));
        })
            .catch(function (err) {
            debug('current session error', err);
            // cookieよりも先にlocalStorage上のトークンの有効期限が切れた場合についてここで扱う。
            // （cookieが先に切れている場合、HTML取得時に401エラー画面が表示されるため、ここには到達しない。）
            // ログインとアプリでUserPoolが違うとページ遷移が無限ループしてしまうため注意すること
            if (!ignoreRedirection) {
                // 401エラー画面と挙動を揃える。（smile-next-web-assets/error/401.html）
                var originValue = encodeURIComponent(window.location.href.replace(window.location.origin, ''));
                window.location.href = "/app/login?origin=" + originValue;
            }
        })
            .finally(function () {
            setIsLoading(false);
            setIsAuthReady(true);
        });
    }, [ignoreRedirection]);
    // プロフィールダイアログからのみ使われるサインアウト処理。
    var signOut = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error, cookieError_1, singOutError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    if (!!ignoreCookie) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get('/cookie/delete', { withCredentials: true })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    cookieError_1 = _a.sent();
                    // CognitoのErrorの場合、既にログアウト済みのため成功とする。そのためエラー処理から除外する。
                    if (isCognitoError(cookieError_1))
                        return [2 /*return*/];
                    error = cookieError_1;
                    debug('error deleting cookie: ', cookieError_1);
                    return [3 /*break*/, 4];
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, Auth.signOut()];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    singOutError_1 = _a.sent();
                    if (isCognitoError(singOutError_1))
                        return [2 /*return*/];
                    error = singOutError_1;
                    debug('error signing out: ', singOutError_1);
                    return [3 /*break*/, 7];
                case 7:
                    setIsLoading(false);
                    if (error) {
                        throw error;
                    }
                    if (!ignoreRedirection) {
                        window.location.href = '/app/login?select=true';
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [ignoreCookie, ignoreRedirection]);
    var getIdToken = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentSession;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Auth.currentSession()];
                case 1:
                    currentSession = _a.sent();
                    return [2 /*return*/, currentSession.getIdToken().getJwtToken()];
            }
        });
    }); }, []);
    // injectMockがtrueのときモックのデータを用いる
    if (env === null || env === void 0 ? void 0 : env.injectMock) {
        return React.createElement(AuthContext.Provider, { value: env.mock }, children);
    }
    return (React.createElement(AuthContext.Provider, { value: {
            isAuthReady: isAuthReady,
            isLoading: isLoading,
            signOut: signOut,
            getIdToken: getIdToken,
            user: user,
        } }, children));
};
var initialState = {
    isAuthReady: false,
    isLoading: false,
    signOut: function () { return Promise.resolve(); },
    getIdToken: function () { return Promise.resolve(''); },
};
export var AuthContext = React.createContext(initialState);
/**
 * 認証情報を取得するReact Hook
 */
export var useAuth = function () { return useContext(AuthContext); };
// @aws-amplify/authのインスタンスと型をexport
export { Auth, CognitoUser };
